import api from "../../api.service"
import { getPaginatedResponse } from "../utils"

import queryString from "query-string"

/**
 * The caller's notifications, newest first, paged by keyset (api/v2/notification).
 * Unlike the v1 list there is no cap at the newest 200: getNext walks the whole
 * history. Filters: type[], typeNot[], org, mission, isRead, isDisabled, limit.
 * People, mission and org come back as ids.
 *
 * @param queryParams {Object}
 * @param [signal] {AbortSignal}
 * @return {Promise<{ value: Array, getNext: Function, hasNext: Function }>}
 */
export function getNotifications(queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)
    return api
        .get(`/v2/notifications?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}
